import {useSelector} from 'react-redux';

import usageStatsService from '../../../../services/uam/usageStatsService';
import {selectIotDeviceType} from '../../../../state/selectors/iotDevice';

const useUsageEnabled = () => {
    const deviceType = useSelector(selectIotDeviceType);

    return usageStatsService.isUsageStatsEnable(deviceType);
};

export default useUsageEnabled;
